import { render, staticRenderFns } from "./SafetEffects.vue?vue&type=template&id=35ddf73c&"
import script from "./SafetEffects.vue?vue&type=script&lang=js&"
export * from "./SafetEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports